import { useMemo, useState, useEffect } from 'react';
import { FocusOn as FocusOn$1 } from 'react-focus-on';
import { isPlatformNodeJS } from '@utils/common';
import { jsx } from 'react/jsx-runtime';

function FocusOn(props) {
  const shards = useMemo(() => {
    const toastsContainer = isPlatformNodeJS() ? undefined : document.querySelector("#snackbar");

    // ensure that AppWriter overlays, which students may use for
    // text-to-speech etc., are interactable even when other content is focussed
    // using FocusOn.
    const appWriterDialog = isPlatformNodeJS() ? undefined : document.querySelector(".appwriter-dialog-element");
    const appWriterPredictionsWrapper = isPlatformNodeJS() ? undefined : document.querySelector("#appwriter-predictions-wrapper");
    const appWriterMenu = isPlatformNodeJS() ? undefined : document.querySelector("#appwriter-menu");
    return [appWriterDialog, appWriterPredictionsWrapper, appWriterMenu, toastsContainer, ...(props.shards ?? [])].filter(it => !!it);
  }, [props.shards]);
  return /*#__PURE__*/jsx(FocusOn$1, {
    ...props,
    returnFocus: props.returnFocus ?? {
      preventScroll: true
    },
    shards: shards
  });
}

/**
 * applying FocusOn during the start of a transition may cause a variety of
 * issues related to mount triggering before unmount of another node, as well
 * as performance considerations.
 *
 * As such this utility ensures that focus on cannot trigger before the enter
 * animation has finished.
 */
function TransitionSafeFocusOn({
  transitionEnterDuration,
  ...props
}) {
  const [transitionEnded, setTransitionEnded] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setTransitionEnded(true);
    }, transitionEnterDuration);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/jsx(FocusOn, {
    ...props,
    enabled: transitionEnded && props.enabled,
    children: props.children
  });
}

export { FocusOn, TransitionSafeFocusOn };
//# sourceMappingURL=focus-on.js.map
